module.exports = __webpack_public_path__ + "static/img/file_folder_document_search_find_scan-512.49384360.png";